import Layout from "./Layout";
import ReferenceHome from "./ReferenceHome";

export default function Home() {
  return (
    <Layout>
      <ReferenceHome />
    </Layout>
  );
}
